<template>
    <vs-popup button-close-hidden :title="title" :active.sync="$store.state.submit_visibility" style="z-index:99990;">
        <div class="vx-col w-full">
            <vx-card :title="title">
                <form>
                    <div class="vx-col w-full">
                        {{text}}
                    </div>
                    <div class="vx-col w-full">
                        <form>
                            <div class="vx-row">
                                <div class="vx-col w-full">
                                    <vs-input placeholder="Remarks ..." label="Remarks" v-model="admin_note" name="Remarks" class="mt-3 w-full" @input="onTypeRemarks" />
                                </div>
                                <div class="vx-col w-full mt-2" v-if="error_msg">
                                    <vs-alert color="danger" icon="new_releases">
                                        <span>{{error_msg}}</span>
                                    </vs-alert>
                                </div>
                            </div>
                        </form>
                    </div>
                    <vs-divider class="mb-base"/>
                    <div class="vx-col w-full">
                        <vs-button type="flat" @click="onClickGoBackRemarkPopUp()" class="mt-5">GO BACK</vs-button>
                        <vs-button type="gradient" color="danger" @click="onClickSubmitRemarkPopup()" class="mt-5">SUBMIT</vs-button>
                    </div>
                </form>
            </vx-card>
        </div>    
    </vs-popup>
</template>

<script>

import Crypto from '@/helper/crypto'
import Global from '@/helper/global'
import ErrorHandler from '@/helper/error_handler'

export default {
    name: 'submit-form-remarks',
    props: ['title', 'text'],
    data () {
        return {
            admin_note: '',
            error_msg: ''
        }
    },
    methods: {
        onClickGoBackRemarkPopUp(){
            this.$emit('close')

            this.$store.commit({
                type: 'SET_POPUP_REMARK_VISIBILITY',
                visibility: false
            })
        },
        onTypeRemarks(value){
            if(value && value.length < 10){
                this.error_msg = 'Please summarize your action in Remarks field'
            } else {
                this.error_msg = ''
            }
        },
        onClickSubmitRemarkPopup(){
            if(this.admin_note){
                this.$emit('onSubmit', this.admin_note)

                this.admin_note = null
                this.$store.commit({
                    type: 'SET_POPUP_REMARK_VISIBILITY',
                    visibility: false
                })
            } else {
                this.error_msg = 'Please summarize your action in Remarks field'
                return 
            }
        }
    }
}
</script>